import { Link, Text, VStack } from '@chakra-ui/react';

import { CONTACT_US } from '../../../../constants/urls';

const SoftCloseMessage = ({ isRefi }: { isRefi: boolean }) => (
  <VStack align="stretch" mt={2} px={2} spacing={4}>
    <Text>
      This is where you'll find updates on your {isRefi ? 'auto refinance status' : 'lease buyout'}{' '}
      as you move forward with our services. We'll keep you informed every step of the way.
    </Text>
    <Text>
      If you have any questions or concerns, please don't hesitate to{' '}
      <Link href={CONTACT_US} isExternal>
        reach out to us
      </Link>
      . Our team is here to help you navigate this process.
    </Text>
    <Text>Thank you for choosing Lease End — we look forward to working with you!</Text>
  </VStack>
);

export default SoftCloseMessage;
